import styled, { css } from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { themeSpace } from 'styles/themeUtils';

const TAB_BORDER = '2px';

export const TabLabelsWrapper = styled.div`
  width: 100%;
  display: flex;

  & > * {
    width: 100%;
    cursor: pointer;
    background-color: transparent;
    outline: 0;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    padding: ${themeSpace(2)} 0;
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    color: ${nuDSColor('black', 'defaultT70')};
    border-bottom: ${TAB_BORDER} solid ${nuDSColor('black', 'defaultT20')};
    text-align: center;

    &.active,
    &:hover,
    &:focus {
      color: ${nuDSColor('primary', 'default')};
    }
  }
`;

export const CurrentTabIndicator = styled.span`
  height: ${TAB_BORDER};
  width: ${({ width }) => width}%;
  background-color: ${nuDSColor('primary')};
  position: relative;
  top: -${TAB_BORDER};
  display: block;
  transform: translateX(${({ offset }) => offset * 100}%);
  transition: 0.75s cubic-bezier(0.23, 1, 0.32, 1);
`;

export const TabButton = styled.button`
  width: 100%;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  padding: ${themeSpace(4)} 0;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  color: ${nuDSColor('black', 'defaultT70')};
  border-bottom: ${TAB_BORDER} solid ${nuDSColor('white', 'dark')};

  ${({ isActive }) => isActive
    && css`
      color: ${nuDSColor('primary')};
    `}

  &:hover,
  &:focus {
    color: ${nuDSColor('primary')};
  }
`;
